import jQuery from "jquery";

const $ = jQuery;

const addVideoControls = (htmlVideo) => {
    const checkIsVideoPaused = (video) => (video.currentTime <= 0 || video.ended || video.paused); // video.readyState <= 2

    const defaultVideoPaused = checkIsVideoPaused(htmlVideo);
    let isPaused = defaultVideoPaused;
    const videoId = htmlVideo.id;
    if (!videoId) {
        // video needs an id
        return;
    }

    const pauseBtn = document.querySelector(`[aria-controls="${videoId}"].play-pause-btn--pause`);
    const playBtn = document.querySelector(`[aria-controls="${videoId}"].play-pause-btn--play`);

    let intervalUpdateBtnStatus = () => {
        const currVideoPaused = checkIsVideoPaused(htmlVideo);
        isPaused = currVideoPaused;
        const videoLoaded = htmlVideo.readyState > 2;
        if (videoLoaded) {
            if (currVideoPaused) {
                pauseBtn.style.display = 'none';
                playBtn.style.display = '';
            } else {
                playBtn.style.display = 'none';
                pauseBtn.style.display = '';
            }
        }
    };
    intervalUpdateBtnStatus = intervalUpdateBtnStatus.bind(this);
    setInterval(intervalUpdateBtnStatus, 500);

    const togglePlayPause = () => {
        if (isPaused) {
            htmlVideo.play();
        } else {
            htmlVideo.pause();
        }
        isPaused = !isPaused;
    };

    document.querySelectorAll(`[aria-controls="${videoId}"]`).forEach((btn) => {
        btn.addEventListener('click', togglePlayPause);
    });
};

const heroBlock = (function ($) { // eslint-disable-line
    const me = {};

    me.init = () => {
        const videos = document.querySelectorAll('video');
        videos.forEach((htmlVideo) => addVideoControls(htmlVideo));
    };

    return me;
}(jQuery));

export default heroBlock;
